import { ReactNode } from 'react';

type TabPanelProps = {
    children?: ReactNode;
    index: number;
    value: number;
};

const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => {
    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
};

export default TabPanel;
